import PropTypes from 'prop-types';
import { useState } from 'react';
import { reports } from '../../../../utils/constant';
import { TRUST_CONTRACT_TYPE_ECC, TRUST_CONTRACT_TYPE_TA } from '../../../../utils/types';
import DownloadModal from '../../../reports/downloadModal/downloadModal';
import EmailModal from '../../../reports/emailModal/emailModal';
import Toolbar from '../../../reports/toolbar/toolbar';

function BeneficiartDetailsTable({ contractData, agreementId, trustContractType }) {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const { agreementPersons, contractNumbers, items, sharedServices } = contractData || {};
  const tempBeneficiaryDetails = agreementPersons?.length ? agreementPersons : [];
  const tempBeneficiaryContractNumbers = contractNumbers?.length ? contractNumbers : [];
  const tempBeneficiaryItems = items?.length ? items : [];
  const tempBeneficiarySharedServices = sharedServices?.length ? sharedServices : [];

  const toggleEmailModal = () => {
    setIsEmailModalOpen(!isEmailModalOpen);
  };

  const toggleDownloadModal = () => {
    setIsDownloadModalOpen(!isDownloadModalOpen);
  };

  const getBeneficiaryItemStatus = (status) => {
    // eslint-disable-next-line no-param-reassign
    status = typeof status === 'string' ? status.toLowerCase() : '';

    switch (status) {
      case 'available':
        return 'item-available';
      case 'used':
        return 'item-used';
      default:
        return '';
    }
  };
  return (
    <div className="trust-beneficiary-details">
      <Toolbar
        optionOneLabel="Email Report"
        optionOneIcon="MdOutlineEmail"
        onOptionOneClick={toggleEmailModal}
        onOptionTwoClick={toggleDownloadModal}
        optionTwoLabel="Download Report"
        optionTwoIcon="FiDownload"
      />
      <div className="beneficiary-details-table-wrapper">
        <table id="beneficiary-details-table" className="beneficiary-details-table">
          <tbody>
            <tr>
              <td>
                <p className="bebeficiary-head">Beneficiary Name</p>
                <p className="bebeficiary-subhead">OPI NUMBER</p>
              </td>
              {tempBeneficiaryDetails.map((beneficiary, index) => {
                return (
                  <td key={index.toString()}>
                    <p className="bebeficiary-head">{beneficiary.label}</p>
                    <p className="bebeficiary-subhead">{beneficiary.opi}</p>
                  </td>
                );
              })}
            </tr>
            <tr>
              <td>trust account number</td>
              {tempBeneficiaryContractNumbers.map((beneficiary, index) => {
                return (
                  <td key={index.toString()} className="bebeficiary-head">
                    {beneficiary}
                  </td>
                );
              })}
            </tr>
            <tr className="item-avail-head">
              <td className="side-head">item name / item code</td>
              <td className="avail-span" colSpan={tempBeneficiaryDetails.length}>
                ITEM AVAILABILITY STATUS
              </td>
            </tr>
          </tbody>
          <tbody className="contract-items-list">
            {tempBeneficiaryItems.map((item, ind) => {
              return (
                <tr key={ind.toString()} className="items-row">
                  {item.map((ele, index) => {
                    if (index === 0)
                      return (
                        <td key={index.toString()}>
                          <p className="item-name">{ele.label}</p>
                          <p className="item-code">{ele.code}</p>
                        </td>
                      );

                    return (
                      <td key={index.toString()} className={getBeneficiaryItemStatus(ele.label)}>
                        {ele.label}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            <tr className="item-avail-head">
              <td className="side-head">Shared services</td>
              <td className="avail-span" colSpan={tempBeneficiaryDetails.length}>
                Item availability status
              </td>
            </tr>
          </tbody>
          <tbody className="shared-services">
            {tempBeneficiarySharedServices.map((item, ind) => {
              return (
                <tr key={ind.toString()} className="items-row">
                  {item.map((ele, index) => {
                    if (index === 0)
                      return (
                        <td key={index.toString()}>
                          <p className="item-name">{ele.label}</p>
                          <p className="item-code">{ele.code}</p>
                        </td>
                      );

                    return (
                      <td key={index.toString()} className={getBeneficiaryItemStatus(ele.label)}>
                        {ele.label}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <EmailModal
          isOpen={isEmailModalOpen}
          toggle={toggleEmailModal}
          reportType={reports.TRUST_ACCOUNT_DETAILS}
          apiValues={{
            agreementId,
            contractType:
              trustContractType === TRUST_CONTRACT_TYPE_ECC ||
              trustContractType === TRUST_CONTRACT_TYPE_TA
                ? 1
                : 0,
          }}
          isTrustAccountParams
        />
        <DownloadModal
          isOpen={isDownloadModalOpen}
          toggle={toggleDownloadModal}
          reportType={reports.TRUST_ACCOUNT_DETAILS}
          urlParams={{
            id: agreementId,
            contractType: trustContractType === TRUST_CONTRACT_TYPE_ECC ? 1 : 0,
          }}
          module="Trust"
        />
      </div>
    </div>
  );
}

BeneficiartDetailsTable.propTypes = {
  contractData: PropTypes.shape({}),
  agreementId: PropTypes.number,
  trustContractType: PropTypes.string,
};

BeneficiartDetailsTable.defaultProps = {
  contractData: undefined,
  trustContractType: undefined,
};

export default BeneficiartDetailsTable;
